//import './index.scss';
import $ from 'jquery';
import './save.cookies';
const {__} = wp.i18n;
import validation from 'jquery-validation';
$(document).ready(function(){
	const  submit  = ($form)=>{
		return new Promise((res, fail)=>{
			var formData = new FormData($form[0]);
			let  url = $form.attr('action')
			if (window.debugAjax){
				$form[0].submit()
			}
			$.ajax({
				url,
				method: 'POST',
				type: 'POST',
				data: formData,
				accepts: {
					json: "application/json"
				},
				dataType: 'json',

				processData: false,
				contentType: false,
				success: r=>{
					if (r.success){
						res(r.data);
					}
					else{
						fail(r)
					}
				},
				error: (e,textStatus, message )=>{
					fail({data:{[textStatus]: message}})
				}
			})
		})
	}

	let renderError = ($form, e)=>{
		let messages = [];
		Object.keys(e.data).map(f=>{
			messages.push(`<b>${f}</b>: ${e.data[f]}`);
		})
		let $errorDiv = $form.find('.wp-block-webfactory-form-part[data-template="error"]')
		
		if ($errorDiv.length){
			$errorDiv.html('<p>'+messages.join('<br>')+'</p>');
			return;
		}

		$('body').append(`<div class="modal modal-error" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
			<div class="modal-header bg-danger text-white">
			<h5 class="modal-title">Error</h5>
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
			<span aria-hidden="true">&times;</span>
			</button>
			</div>
			<div class="modal-body">
			<p>${messages.join('<br>')}</p>
			</div>
			<div class="modal-footer">
			<button type="button" class="btn btn-secondary" onclick="jQuery(this).parents('.modal').modal('hide').remove()" data-dismiss="modal">Ok</button>
			</div>
			</div>
			</div>
			</div>`)
		$('.modal-error').modal('show');

	}

	let validate = function(el) {
		let $btn = $(el).find('[data-bs-toggle="form-validation"]');
		let $x = $(el).find('select[data-required]').attr('required', 'required');
		return $(el).validate({
			ignore: '',
			errorPlacement: function ($error, $element) {
				$element.parents('.wp-block-webfactory-field').append($error);
			},
			invalidHandler: function(form, validator) {
				if (!validator.numberOfInvalids())
					return;
				let $field = $(validator.errorList[0].element).parents('.wp-block-webfactory-field');
				$('html, body').animate({
					scrollTop: $field.offset().top - 300
				}, 500);
			},

			errorClass: 'is-invalid',
			validClass: 'is-valid',
			submitHandler: function(form){
				if ($btn.length && !$($btn.data('bs-target')).hasClass('show')){
					$btn.click();
					return;
				}

				$(form).find('[type="submit"] .wf-icon').hide();
				$(form).find('.wp-block-webfactory-form-part[data-template="error"]').html('');
				$(form).find('[type="submit"] .--loader').show();
				submit($(form)).then((r)=>{
					$(form).find('[type="submit"] .--loader').hide();
					$(form).find('[type="submit"] .--success').show();
					$(form).removeClass('--error').addClass('--success')

					$(form).trigger('success.submit', r,r);
				}).catch(function(e){
					$(form).find('[type="submit"] .--loader').hide();
					$(form).find('[type="submit"] .--error').show();
					$(form).find('.modal').modal('hide');
					$(form).removeClass('--success').addClass('--error')
					$(form).trigger('fail.submit');
					console.error(e);

					renderError($(form), e)

				})
			}
		})
	}
	$(document).on('success.submit', 'form.wp-block-webfactory-form', function(e,data){
		$(this).find('.modal').modal('hide')
		if ($(this).data('onSuccess')=='hide'){
			$(this).children().each(function(){
				if (!$(this).is('[data-template="success"]')  && !$(this).hasClass('is-style-success')){
					$(this).remove();
				}
			})
		}
		if ($(this).data('onSuccess')=='reset'){
			this.reset();
		}
		if ($(this).data('onSuccess')=='redirect'){
			let $url = $(this).data('redirectUrl');
			if ($url){
				window.location.href = $url;
			}
			return;
		}
	});
	$(document).on('click', 'form.wp-block-webfactory-form [data-bs-toggle="form-validation"]', function(e){
		const target = $(this).data('bsTarget');
		if (!target){
			console.error('target not set for this button');
			return;
		}
		let $modal = $(target);
		if (!$modal.length){
			console.error('target not found for modal ('+target+')');
			return;
		}
		if ($(this).parents('form').valid()){
			$modal.modal('show');
			let $submit = $modal.find('input[type="submit"]');
			if ($submit.length){
				setTimeout($submit[0].focus, 200)
			}
		}
	});
	setTimeout(()=>{
		validate($('form.wp-block-webfactory-form'))
	}, 10)

})
$.extend($.validator.messages, {
	required: __("This field is required.", 'webfactory-forms'),
	remote: __("Please fix this field.", 'webfactory-forms'),
	email: __("Please enter a valid email address.", 'webfactory-forms'),
	url: __("Please enter a valid URL.", 'webfactory-forms'),
	date: __("Please enter a valid date.", 'webfactory-forms'),
	dateISO: __("Please enter a valid date (ISO).", 'webfactory-forms'),
	number: __("Please enter a valid number.", 'webfactory-forms'),
	digits: __("Please enter only digits.", 'webfactory-forms'),
	creditcard: "Please enter a valid credit card number.",
	equalTo: "Please enter the same value again.",
	accept: "Please enter a value with a valid extension.",
	maxlength: $.validator.format("Please enter no more than {0} characters."),
	minlength: $.validator.format("Please enter at least {0} characters."),
	rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
	range: $.validator.format("Please enter a value between {0} and {1}."),
	max: $.validator.format("Please enter a value less than or equal to {0}."),
	min: $.validator.format("Please enter a value greater than or equal to {0}.")
});
if (window.Webfactory && Webfactory.translations){
	Object.keys(Webfactory.translations.form).map(key=>{
		$.validator.messages[key] = $.validator.format(Webfactory.translations.form[key]);
	});
}
